import QuoteCallout from '../../../molecules/quoteCallout/QuoteCallout';
import CustomVideo from '../../customVideoControls';
import PlaceholderImage from '../../../atoms/placeholderImage';
import defaultStyles from '../ProductGallery.module.scss';
import React, { useEffect, useState } from 'react';
import mergeClasses from '../../../../utils/shallowMerge';
import { customStylesQuote } from '../options';
import { ImageWithOverlay } from '../../../atoms/image/ImageWithOverlay';
import { theme } from "./_vars";

// render prop try

const DesktopGallery = ({
  images,
  text,
  textAuthor,
  setZoomItem,
  isDemo = false,
  alt = '',
  customClasses,
  productOverlayUrl,
}) => {
  const [demoStatus, setDemoStatus] = useState(isDemo);
  const styles = mergeClasses(defaultStyles, customClasses);

  const defaultImages = !images || !images.length ? [{}] : images;
  const firstImageIndex = defaultImages.findIndex((x) => !!x.url);
  const modifiedArray = [...defaultImages].map((item, index) => {
    return ({
      ...item,
      showOverlay: theme === 'jag' ? firstImageIndex === index : true,
    });
  });

  const renderText = (
    <div>
      <QuoteCallout
        text={text}
        author={textAuthor}
        alignQuote="center"
        weightQuote="light"
        sizeAuthor="xs"
        weightAuthor="bold"
        customClasses={customStylesQuote}
      />
    </div>
  );

  let calculatedImagesLength = defaultImages.length;

  useEffect(() => {
    if (!images || !images.length) {
      setDemoStatus(true);
    }
  }, []);

  if (text) {
    modifiedArray.splice(2, 0, renderText);
  }

  const renderElement = (el, shouldPreloadImage = false) => {
    if (el.type === 'div') {
      return el;
    }

    if (el.videoUrl)
      return (
        <CustomVideo
          videoUrl={el.videoUrl}
          overlayUrl={theme !== 'jag' ? productOverlayUrl : null}
          alt={alt}
        />
      );
    return (
      <div
        key={el.id}
        className={`${styles.block} ${!demoStatus && styles.cursorWithDemo}`}
        onClick={() =>
          !demoStatus &&
          setZoomItem({
            enabled: true,
            mainImage: el,
          })
        }
      >
        {!el.url ? (
          <PlaceholderImage className={styles.imageTile} />
        ) : (
          <ImageWithOverlay
            alt={alt}
            title={alt}
            itemProp="image"
            preloadImage={shouldPreloadImage}
            className={styles.imageTile}
            overlayUrl={el?.showOverlay && productOverlayUrl}
            image={el.url}
            opts={{
              crop: 'fill',
              width: 1256,
              sirvWidth: 440,
              sirvHeight: 560,
            }}
          />
        )}
      </div>
    );
  };

  const evenOddPosition = (imagesLength) => {
    let result = [];

    if (imagesLength % 2 === 0) {
      result = modifiedArray.map((el, index) => {
        if (el.type === 'div') {
          return (
            <div key={`type_div_${index}`} className={styles.full}>
              {renderElement(el, index < 2)}
            </div>
          );
        }
        return (
          <div key={`default_${index}`} className={styles.even}>
            {renderElement(el, index < 2)}
          </div>
        );
      });
    } else if (imagesLength === 1) {
      result = modifiedArray.map((el, index) => {
        return (
          <div key={index} className={styles.full}>
            {renderElement(el, true)}
          </div>
        );
      });
    } else if (imagesLength === 3 && text) {
      const first = modifiedArray.slice(0, 2);
      const second = modifiedArray.slice(-2).reverse();

      const threeColumnsVariant = [...first, ...second].map((el, index) => {
        if (el.type === 'div') {
          return (
            <div key={`div_${index}`} className={styles.full}>
              {renderElement(el, index < 2)}
            </div>
          );
        }
        return (
          <div key={`element_${index}`} className={styles.odd}>
            {renderElement(el, index < 2)}
          </div>
        );
      });

      return threeColumnsVariant;
    } else {
      const beforeLastRow = modifiedArray
        .slice(0, modifiedArray.length - 3)
        .map((el, index) => {
          if (el.type === 'div') {
            return (
              <div key={`${index}_div`} className={styles.full}>
                {renderElement(el, index < 2)}
              </div>
            );
          }
          return (
            <div key={`${index}_default`} className={styles.even}>
              {renderElement(el, index < 2)}
            </div>
          );
        });
      const lastRow = modifiedArray.slice(-3).map((el, index) => {
        return (
          <div key={`lastRow_${index}`} className={styles.odd}>
            {renderElement(el)}
          </div>
        );
      });

      result = [...beforeLastRow, ...lastRow];
    }

    return result;
  };

  return (
    <div className={styles.wrapper}>
      {evenOddPosition(calculatedImagesLength)}
    </div>
  );
};

export default DesktopGallery;
